var map = {
	"./errorLog.js": "./src/store/modules/errorLog.js",
	"./pagaCloudBackground.js": "./src/store/modules/pagaCloudBackground.js",
	"./routes.js": "./src/store/modules/routes.js",
	"./settings.js": "./src/store/modules/settings.js",
	"./table.js": "./src/store/modules/table.js",
	"./tabsBar.js": "./src/store/modules/tabsBar.js",
	"./user copy.js": "./src/store/modules/user copy.js",
	"./user.js": "./src/store/modules/user.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync \\.js$";